// extracted by mini-css-extract-plugin
export default {"component":"hKfu7j","with-border":"kH4uf8","background-main":"TxZf_B","background-secondary":"FJ2ntf"};